import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupplyRegisterPerThirdPartyPropertyService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SupplyRegisterPerThirdPartyPropertyCreateDto,
  SupplyRegisterPerThirdPartyPropertyDto,
  SupplyRegisterPerThirdPartyPropertyExcelDownloadDto,
  SupplyRegisterPerThirdPartyPropertyUpdateDto,
} from '../proxy/planning/dtos/supply-register-per-third-party-property';
import { SUPPLYREGISTERPERTHIRDPARTYPROPERTY_CONFIG, SUPPLYREGISTERPERTHIRDPARTYPROPERTY_FIELDS } from './supply-register-per-third-party-property.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-supply-register-per-third-party-property',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SupplyRegisterPerThirdPartyPropertyService, ConfirmationService],
  templateUrl: './supply-register-per-third-party-property.html',
  styleUrl: './supply-register-per-third-party-property.scss',
})
export class SupplyRegisterPerThirdPartyProperty extends BaseHierarchicalCrudComponent<
  SupplyRegisterPerThirdPartyPropertyDto,
  SupplyRegisterPerThirdPartyPropertyCreateDto,
  SupplyRegisterPerThirdPartyPropertyUpdateDto,
  SupplyRegisterPerThirdPartyPropertyExcelDownloadDto
> {
  service = inject(SupplyRegisterPerThirdPartyPropertyService);
  config = SUPPLYREGISTERPERTHIRDPARTYPROPERTY_CONFIG;
  fields = SUPPLYREGISTERPERTHIRDPARTYPROPERTY_FIELDS;

  protected prepareUpdateDto(data: any, selected: SupplyRegisterPerThirdPartyPropertyDto): SupplyRegisterPerThirdPartyPropertyUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SupplyRegisterPerThirdPartyProperty';
  }
}
